import React, {useState, useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../features/user";
import { showErrorDialog } from "../../features/errorDialog";
import axios from "axios";
import { API_OK, API_URL, DEFAULT_ERROR_TITLE, DEFAULT_ERROR_TEXT, API_EXCEPTION, APP_NAME_SIMKEHILOT, getActiveAppName, getBrandDisplayName, getSupportPhone } from '../../Constants';
import { Button, Typography, TextField, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import cookie from "js-cookie";
import {handleApiErrorMessage, formatErrorMessage, getCommunityGeneralInfo} from "../../Helper"
import { logout } from "../../features/user";
import { hideErrorDialog } from "../../features/errorDialog";

const APP_NAME = getActiveAppName();

export function Login() {
    const [state, setState] = useState({ username: "", password: "" });
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const errorDialog = useSelector((state) => state.errorDialog.value);
    
    const handleErrorDialogClose = () => {
        dispatch(hideErrorDialog());
      };

    useEffect(() => {
        let errorMessage = cookie.get('logout_error');
        if(errorMessage !== "null" && (typeof errorMessage !== 'undefined')){
            const errorMessageToDisplay = formatErrorMessage(errorMessage, t);
            dispatch(showErrorDialog({title : t(DEFAULT_ERROR_TITLE), text: errorMessageToDisplay, page: "login"}));
            cookie.set('logout_error', "null");
        }
      }, []);

    const handleChange = (e) => {
        setState({
            ...state,
            [e.target.id]: e.target.value
        });
    };

    const handleInvalid = (e) => {
        if(e.target.value === ""){
            e.target.setCustomValidity(t("Please fill in the field"));
        }else{
            e.target.setCustomValidity("");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        let errorMessage = t(DEFAULT_ERROR_TEXT);
        const data = {userName: state.username, password: state.password};
    
        try {
            const reply = await axios.post(API_URL + '/login', data);
            if(reply.hasOwnProperty('data') && reply.data.hasOwnProperty('responseStatus') && reply.data.responseStatus === API_OK
                && reply.data.hasOwnProperty('token')){
                const communityGeneralInfo = await getCommunityGeneralInfo(reply.data.token, t, dispatch, showErrorDialog, logout, navigate);
                document.title = reply.data.webConfig.title;
                localStorage.setItem('show_red_inactive_lines', communityGeneralInfo.showRedInactiveLines);
                localStorage.setItem('allow_unblock_line_from_invalid_imei', communityGeneralInfo.allowUnblockLineFromInvalidImei);
                localStorage.setItem('portal_access', JSON.stringify(communityGeneralInfo.portalAccess || {}));
                localStorage.setItem('community_type', communityGeneralInfo.communityType || 'REGULAR');
                localStorage.setItem('block_list_policy', JSON.stringify(communityGeneralInfo.blockListPolicy || {}));
                dispatch(login({token : reply.data.token, community_name: communityGeneralInfo.name, smsWatchSystemAllow: communityGeneralInfo.smsWatchSystemAllow}));
                navigate("/dashboard");
            }else{
                if((reply.data.responseStatus === API_EXCEPTION) && (reply.data.hasOwnProperty("message"))){
                    errorMessage = reply.data["message"];
                  }
                  handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate, "login");
            };
        } catch (e) {
            handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate, "login");
        }
    };

    return (
        <div className='lgn-root'>
            <div className='lgn-blob lgn-blob-1' />
            <div className='lgn-blob lgn-blob-2' />
            <div className='lgn-blob lgn-blob-3' />

            {/* slowly drifting shapes behind the card - decoration only */}
            <div className='lgn-floats' aria-hidden='true'>
                <span className='lgn-float lgn-float-1' />
                <span className='lgn-float lgn-float-2' />
                <span className='lgn-float lgn-float-3' />
                <span className='lgn-float lgn-float-4' />
                <span className='lgn-float lgn-float-5' />
                <span className='lgn-float lgn-float-6' />
            </div>

            <div className='lgn-card'>
                <div className='lgn-logo'>
                    <img src={'/design-images/' + APP_NAME + '/logo.png'} alt='' />
                </div>
                <h1 className='lgn-title'>ברוכים הבאים</h1>
                <p className='lgn-sub'>{t('Welcome back, please insert login details')}</p>

                <form onSubmit={handleSubmit} className='lgn-form'>
                    <div className='lgn-field'>
                        <svg className='lgn-field-icon' width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                        <input
                            className='lgn-input'
                            type='text'
                            id='username'
                            placeholder={t('Username')}
                            required
                            onChange={handleChange}
                            onInvalid={handleInvalid}
                        />
                    </div>
                    <div className='lgn-field'>
                        <svg className='lgn-field-icon' width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                        <input
                            className='lgn-input'
                            type='password'
                            id='password'
                            placeholder={t('Password')}
                            required
                            onChange={handleChange}
                            onInvalid={handleInvalid}
                        />
                    </div>
                    <button type='submit' className='lgn-btn'>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/><polyline points="10 17 15 12 10 7"/><line x1="15" y1="12" x2="3" y2="12"/></svg>
                        {t('Login')}
                    </button>
                </form>

                {errorDialog.isOpen && errorDialog.page === 'login' && (
                    <div className='lgn-error'>
                        <span className='lgn-error-icon'>!</span>
                        <div className='lgn-error-text'>
                            <div className='lgn-error-title'>{t('INCORRECT_LOGIN')}</div>
                            <div className='lgn-error-sub'>{t('Please contact support at {{phone}}', { phone: getSupportPhone() })}</div>
                        </div>
                        <button className='lgn-error-close' onClick={handleErrorDialogClose}>✕</button>
                    </div>
                )}

                <div className='lgn-foot'>{getBrandDisplayName()}</div>
            </div>
        </div>
    );
}